import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import UserInfoService from "services/AccountInfo/";
import PubSub from 'services/PubSub/';
import Loader from "components/Loader/";
import Rut from 'components/Forms/Inputs/InputRut';
import Checkbox from 'components/Forms/Inputs/ChecksGroup/checkbox'
import { actionsType } from 'config/constants'
import InputCelPhone from 'components/Checkout/CheckoutSteps/Identificacion/InputCelPhone'
import { regexValidDate,formatRut } from 'utils';
import Day from 'dayjs';
import PrimeService from 'services/Prime';
import TagManagerService from 'services/TagManager/';
import StorageService from 'services/StorageService';
import style from './style.scss';//NOSONAR


let actions = [];
let userInfo = {};
let dateEndService = '';


const RegisterPrime = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [formIsValid, setFormIsValid] = useState(false);
    const [rutIsValid, setRutIsValid] = useState(false);
    const [phoneIsValid, setPhoneIsValid] = useState(false);
    const [phoneValue, setPhoneValue] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [rutValue, setRutValue] = useState('');
    const [checkbox, setCheck] = useState(false);
    const [checkboxFidelity, setCheckFidelity] = useState(false);
    const [birthDateError, setBirthDateError] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    let birthDateMessage = "Debe ingresar una fecha válida";
    const inputDate = useRef(null);

    useEffect(() => {

        let pathName = window.location.pathname;
        pathName = pathName.includes('/registrate-prime') ? pathName : '/quiero-ser-prime' ;
        TagManagerService.pageviewVirtual(pathName);

        getStatusPrime();
        UserInfoService.getUser().then(results => {
            userInfo = results;
            const fecha = userInfo.birthDate ? userInfo.birthDate.substring(0,10): '';
            setIsLoaded(true);
            setLastName(userInfo.lastName);
            setFirstName(userInfo.firstName);
            setPhoneValue(userInfo.homePhone);
            setEmail(userInfo.email)
            setRutValue(userInfo.document ? userInfo.document : '');
            setBirthDate(userInfo.birthDate ? userInfo.birthDate = fecha.slice(-2) +"/"+ fecha.slice(5,7) + "/" + fecha.slice(0,4) : '');
        }, []);

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
            dateEndService = '';

        }
    }, []);

    useEffect(() => {
        validateForm();
    }, [rutIsValid,phoneIsValid, checkbox, checkboxFidelity])


    const validateForm = () => {
        let fechaValida = regexValidDate();
        const _tlfnIsValid = phoneIsValid;

        const isvalid = !!rutIsValid &&
            !!_tlfnIsValid &&
            !!fechaValida.exec(inputDate.current.value) && !!checkbox && !!checkboxFidelity;
        if(isvalid !== formIsValid){
            setFormIsValid(isvalid)
        }
    }
    
    const changeBirthDate = (value) => {
        let fechaValida = regexValidDate();
        setBirthDate(value);
        validateForm();

        if(value.length < birthDate.length){
            setBirthDateError(false);
            validateForm();
        }else{
            if(value.length == 3){
                if(value.slice(-1) != "/"){
                    setBirthDate(value.slice(0, 2) + "/" + value.slice(2));
                    validateForm();
                }
            }
            if(value.length == 6){
                if(value.slice(-1) != "/"){
                    setBirthDate(value.slice(0, 5) + "/" + value.slice(5));
                    validateForm();
                }
            }
            if(value.length == 10){
                if(!fechaValida.exec(value)){
                    setTimeout(()=>{
                        setBirthDateError(true);
                        validateForm();
                    },1000);
                }
                if(fechaValida.exec(value)){
                    setTimeout(()=>{
                        setBirthDateError(false);
                        validateForm();
                    }, 1);
                }
            }
        }
    }

    const blurBirthDate = (value) => {
        let fechaValida = regexValidDate();
        if(!fechaValida.exec(value)){
            setTimeout(()=>{
                setBirthDateError(true);
                validateForm();
            }, 100)
        }
    }
    
    const rutValid = (valid, value) => {
        setRutIsValid(valid);
        setRutValue(value);
    }

    const onChangeInput = () => {
        setCheck(!checkbox)
    }

    const onChangeInputFidelity = () => {
        setCheckFidelity(!checkboxFidelity)
    }

    const phoneValid = (phone) => {
        isValid(true);
        if (phone) {
            setPhoneValue(phone)
        }
    }

    const isValid = (valid) => {
        setPhoneIsValid(valid);
    }

    const onSubmit = (event) => {
        event.preventDefault();
        validateForm()
    };

    const gotBackInvitation = () => {

        const userData = StorageService.getSecureItem('userData');
        let userId = userData?.gtmSegment;
        TagManagerService.interaction('Clic botón volver Step 1 Inscripción: Formulario datos', userId, 'Jumbo Prime');

        // PubSub.dispatch(actionsType.DRAWER.INVITATION_PRIME_OPEN)
        if(userData.firstName){
            
            PubSub.dispatch(actionsType.DRAWER.REGISTER_PRIME_CLOSE)
            PubSub.dispatch(actionsType.DRAWER.INVITATION_PRIME_OPEN)
        } else {
            PubSub.dispatch(actionsType.DRAWER.REGISTER_PRIME_CLOSE)
            PubSub.dispatch(actionsType.DRAWER.LOGIN_OPEN)
        }
        
    }
    const callbackSuccess = (card, cupon) => {
        let _birthDay =  birthDate.replace(/\//g, '');
        _birthDay = _birthDay.slice(-4) + '-' + _birthDay.slice(2, 4)  + '-' + _birthDay.slice(0, 2);

        const formRegisterData = {
            'dateBirth': Day(_birthDay).format('YYYY-MM-DD'),
            'firstName': firstName,
            'lastName': lastName,
            'dni': (rutValue && formatRut(rutValue)) ? formatRut(rutValue).replaceAll("." ,"") : rutValue,
            'cardBin': card.lastDigits,
            'cardToken': card.token,
            'cardBrand': card.brand,
            'accepts': checkbox,
            'acceptsFidelity': checkboxFidelity,
            'phone': phoneValue,
            'couponCode': cupon || '',
        }
        const body = {};
        if(!userInfo.document) {
            body.document = rutValue.replace('-', '');
        }
        if(!userInfo.homePhone || phoneValue !== userInfo.homePhone) {
            body.homePhone = phoneValue;
        }
        if(!userInfo.birthDate || userInfo.birthDate !== birthDate) {
            body.birthDate = Day(_birthDay).format('YYYY-MM-DD');
        }
        const requestUserData = [];
        if(Object.keys(body).length){
            requestUserData.push(UserInfoService.updateUser(body));
        }
        return Promise.all(requestUserData) 
            .then(() => {  
                return PrimeService.register(formRegisterData).then((response) => {
                    if(response.statusCode === 200) {
                        return _successRegister(body)
                    }
                    return response
                })
            })
    }

    const _successRegister = (body) => {
        let data = StorageService.getSecureItem('userData');
        if(body?.birthDate) data.birthDate = body.birthDate;
        if(body?.phone) data.homePhone = body.phone;
        data.CencoPrime_2020 = true;
        return PrimeService.primeDate().then(result => {
            data.prime_invitation_date = result.date;
            StorageService.setSecureItem('userData', data);
            setTimeout(() => {
                PubSub.dispatch(actionsType.DRAWER.PAYMENT_METHOD_PRIME_CLOSE)
            },1)
            setTimeout(() => {
                PubSub.dispatch('reload_prime');
                PubSub.dispatch(actionsType.DRAWER.WELCOME_PRIME_OPEN)
            }, 300);
            return result;
        })
    }

    const callbackGoBack = () => {
        setTimeout(()=> {
            PubSub.dispatch(actionsType.DRAWER.REGISTER_PRIME_OPEN)
        },200)
    }

    const addPayment = () => {

        const userData = StorageService.getSecureItem('userData');
        let registered = userData.homePhone ? 'Registrado' : 'Cliente nuevo';
        TagManagerService.interaction('Step 1 Inscripción: Formulario datos', registered, 'Jumbo Prime');  

        PubSub.dispatch(actionsType.DRAWER.REGISTER_PRIME_CLOSE)
        StorageService.setSecureItem('register_prime_data', {firstName, lastName, birthDate,rutValue, phoneValue, userInfo, checkbox})
        setTimeout(()=> {
            PubSub.dispatch(actionsType.DRAWER.PAYMENT_METHOD_PRIME_OPEN, {init: true, register: true, callbackSuccess, callbackGoBack})
        },200);
    }
    const getStatusPrime = () => {
        PrimeService.getSuscription().then(res => {
            if((res?.data?.data?.status === 6) || (res?.data?.data?.status === 7)){
                if(res?.data?.data?.benefit_end_date){
                    const diff = Day(res?.data?.data?.benefit_end_date).diff(Day());
                    dateEndService = Day(res?.data?.data?.benefit_end_date).format('DD/MM/YYYY');
                    const diffDays = Math.round(((diff/1000)/3600)/24);
                    setShowMessage(diffDays);
                }else{
                    setShowMessage(false)
                }
            }else{
                setShowMessage(false)
            }
        })
    }
     
    return(
        <div className={'drawer-container'}>
            <h1 className="drawer-title">Regístrate en Jumbo Prime</h1>
            <div className={'drawer-scroll drawer-prime-register-content'}>
                <div className="container-prime-register">
                    {(showMessage && showMessage >= 1) && <div className="prime-header">
                        <span className="message-begin-date"><strong>Tu periodo de prueba sin costo finaliza el {dateEndService}.</strong> Luego, si deseas mantener tu suscripción, debes pagar un monto de $25.000 y obtendrás 6 meses de descuentos y beneficios. Puedes cancelar tu suscripción en cualquier momento sin problemas.</span>
                    </div>}
                    {((typeof showMessage === 'number') && showMessage <= 0) && <div className="prime-header">
                        <span className="message-begin-date">Por solo $25.000 disfruta de 6 meses de beneficios. <strong>Cancela online, cuando quieras y sin compromisos.</strong></span>
                    </div>}
                    {(!showMessage && typeof showMessage !== 'number') && <div className="prime-header">
                        <span className="message-begin-date">Inicia tu periodo de prueba <strong>sin costo por 15 días</strong>, luego solo $25.000 y disfruta 6 meses de beneficios. <strong>Cancela online, cuando quieras y sin compromisos.</strong></span>
                    </div>}
                    <div className="prime-user-infor">
                        <div className="user-info-name">
                            <label className="info-title">Nombre</label>
                            <span className="info-value">{firstName} {lastName}</span>
                        </div>
                        <div className="user-info-mail">
                            <label className="info-title">Email</label>
                            <span className="info-value">{email}</span>
                        </div>
                    </div>
                    <form className="form-register-prime">
                        {!isLoaded && <div className="register-prime-loader"><Loader/></div>}
                        <div className="input-row">
                            <div className={'half-input-rut'}>
                                <label className="required">RUT</label>
                                <Rut callbackisValid={rutValid} defaultRut={userInfo.document ? userInfo.document : ''} placeholder={'11111111-1'} focus={true}/>
                            </div>
                        </div>
                        <div className="input-row">
                            <div className={'half-input input-wrapper' + (birthDateError ? ' input-error' : '')}>
                                <label className="required">Fecha de nacimiento</label>
                                <input ref={inputDate} value={birthDate ? birthDate : ''} maxLength="10" name="birth" placeholder="(Ej: 01/01/1981)" onBlur={(event) => blurBirthDate(event.target.value)} onChange={(event) => changeBirthDate(event.target.value)} className={"input-default"}/>
                                {birthDateError && <i className="jumbo-icon-new-close"></i>}
                                <p className="input-error-message">
                                    {birthDateError ? birthDateMessage : '-'}
                                </p>
                            </div>
                            <div className={'half-input'}>
                                <label className="client-information-phone required">Télefono</label>
                                <div className="phone-information-wrap">
                                    <InputCelPhone phone={phoneValue ? phoneValue : ''} callback={phoneValid} callbackisValid={isValid} callbackOnkeyPress={onSubmit}/>
                                </div>
                            </div>
                        </div>
                        <div className="input-row">
                            <label className="register-prime-input-container">
                                <Checkbox
                                    type={'checkbox'}
                                    name={'Terms resgister prime'}
                                    checked={checkbox}
                                    onChange={onChangeInput}
                                />
                                <span className="register-prime-terms-span">Acepto <a href="https://jumboprime.cl/terminos-y-condiciones" className="new-link new-link-small register-link" target={'_blank'}>Términos y condiciones</a> y <a href="https://jumboprime.cl/politicas-y-proteccion" className="new-link new-link-small register-link" target={'_blank'}>Políticas de Privacidad</a> de Jumbo Prime</span>
                            </label>
                        </div>
                        <div className="input-row">
                            <label className="register-prime-input-fidelity-container">
                                <Checkbox
                                    type={'checkbox'}
                                    name={'Terms resgister fidelity'}
                                    checked={checkboxFidelity}
                                    onChange={onChangeInputFidelity}
                                />
                                <span className="register-prime-terms-span">Acepto <a href="https://www.puntoscencosud.cl/puntos/terminos%20y%20condiciones" className="new-link new-link-small register-link" target={'_blank'}>Términos y condiciones</a> y <a href="https://www.puntoscencosud.cl/puntos/politicas%20de%20privacidad" className="new-link new-link-small register-link" target={'_blank'}>Políticas de Privacidad</a> del Programa Puntos Cencosud</span>
                            </label>
                        </div>
                    </form>
                </div>
            </div>
            <div className="drawer-actions">
                <button className="secundary-btn prime-register-btn-back" onClick={gotBackInvitation}>Volver</button>
                <button className={(formIsValid ? 'primary-btn prime-register-btn-prime ' : 'disabled-btn') } onClick={addPayment}>Continuar</button>
            </div>
        </div>

    )
}

RegisterPrime.propTypes = {
    basicInfo: PropTypes.object,
    closeEditUser: PropTypes.func
};

export default RegisterPrime;


